exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".preview {\n  position: absolute;\n  top: 0px;\n  bottom: 0px;\n  right: 0px;\n  left: 0px; }\n\n.preview-iframe {\n  height: 100%;\n  width: 100%; }\n", ""]);

// exports
